import React, { useContext, useEffect, useState } from 'react';
import { AppContext, DataList } from 'commons-ui';
import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';
import { Button } from 'baseui/button';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { TournamentListConfig } from './listConfig';
import { ZUPEE_GAMES } from '../../utils/constants';

const TournamentList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const [css] = useStyletron();
	const actions = getActionList();
	const { app } = useContext(AppContext);
	const { getTournamentConfigs } = useService();

	const [gameName, setGameName] = useState(ZUPEE_GAMES[0]);
	const [refresh, setRefresh] = useState(false);
	const [forceUpdateTournamentList, setForceUpdateTournamentList] = useState(false);
	const handleChange = (option?: any) => {
		setGameName(option);
	};
	const onRefresh = () => {
		setRefresh(true);
	};
	const handleSubmit = async () => {
		const result = getTournamentConfigs({ app }, gameName.id);
		setForceUpdateTournamentList(false);
		setRefresh(false);
		return result;
	};
	useEffect(() => {
		setForceUpdateTournamentList(true);
	}, [gameName, refresh]);
	return (
		<>
			<div className={css({ display: 'flex', width: '50%', justifyContent: 'center', margin: 'auto' })}>
				<div
					className={css({
						width: '230px !important'
					})}>
					<Select
						options={ZUPEE_GAMES}
						overrides={{
							ControlContainer: {
								style: ({ $theme }) => ({
									backgroundColor: $theme.colors.contentInverseTertiary
								})
							}
						}}
						labelKey='label'
						valueKey='id'
						searchable={false}
						clearable={false}
						onChange={({ option }) => handleChange(option)}
						value={[gameName]}
					/>
				</div>
				<Button size='compact' onClick={onRefresh}>
					Refresh
				</Button>
			</div>
			<DataList
				fetchData={handleSubmit}
				columnConfigs={TournamentListConfig()}
				getActionHandler={getActionHandler}
				actions={actions}
				rowHeight={100}
				entity={LIST_ENTITY_NAMES.TOURNAMENT_BUCKETS}
				globalForceUpdate={forceUpdateTournamentList}
			/>
		</>
	);
};

export default TournamentList;
